import { FieldConfig } from "../../../components/form/FieldRenderer";

export const licenseCount: FieldConfig[] = [
  {
    name: "no_of_licenses",
    label: "How many licenses would you like to remove?",
    type: "text",
    required: true,
  },
];
